import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { getAppSettings } from "../lib/appSettings";
import { formatCoins } from "../lib/format";
import { FESTIVAL_THEMES } from "../lib/festivals";

const left = (end) => Math.max(0, Math.floor((new Date(`${end}T23:59:59+05:30`) - Date.now()) / 1000));

function Countdown({ end }) {
  const [s, setS] = useState(() => left(end));
  useEffect(() => { const id = setInterval(() => setS(left(end)), 1000); return () => clearInterval(id); }, [end]);
  const parts = [[Math.floor(s / 86400), "दिन"], [Math.floor((s % 86400) / 3600), "घंटे"], [Math.floor((s % 3600) / 60), "मिनट"], [s % 60, "सेकंड"]];
  return (
    <div className="flex items-center gap-1.5" data-testid="festival-countdown">
      <Clock size={14} className="text-amber-300 shrink-0" />
      {parts.map(([v, l]) => (
        <span key={l} className="rounded-lg bg-black/40 border border-white/10 px-2 py-1 text-center min-w-[44px]">
          <b className="block font-mono-num text-base text-amber-200 leading-none">{String(v).padStart(2, "0")}</b>
          <span className="text-[9px] text-slate-400">{l}</span>
        </span>
      ))}
    </div>
  );
}

export default function FestivalBanner({ compact = false }) {
  const [fe, setFe] = useState(null);
  useEffect(() => { getAppSettings().then((d) => setFe(d.festival)).catch(() => {}); }, []);
  if (!fe?.active) return null;
  const th = FESTIVAL_THEMES[fe.theme] || FESTIVAL_THEMES.shivratri;
  const hasBonus = fe.bonus_percent > 0 && fe.bonus_max > 0;
  return (
    <div data-testid="festival-banner" className={`relative overflow-hidden rounded-2xl border ${th.border} bg-gradient-to-r ${th.bg} animate-pulse-glow`}>
      <div className="flex flex-wrap items-center gap-4 p-4">
        {!compact && fe.banner_url && <img src={fe.banner_url} alt="" className="hidden sm:block h-20 w-32 rounded-xl object-cover ring-1 ring-amber-400/40" />}
        <span className="text-4xl animate-trishul" aria-hidden>{th.icon}</span>
        <div className="min-w-0 flex-1">
          <p className="font-display text-lg sm:text-xl font-extrabold gold-text" data-testid="festival-title">{fe.title}</p>
          {fe.subtitle && <p className="text-sm text-orange-100/90">{fe.subtitle}</p>}
          {hasBonus && (
            <p className="mt-1 text-xs font-bold text-amber-200" data-testid="festival-bonus-info">
              +{fe.bonus_percent}% बोनस हर डिपॉज़िट पर (ज़्यादा से ज़्यादा {formatCoins(fe.bonus_max)})
            </p>
          )}
        </div>
        {fe.end_date && (
          <div className="space-y-1">
            <p className="text-[10px] uppercase tracking-wider text-slate-300">{hasBonus ? "बोनस ख़त्म होने में" : "ऑफ़र ख़त्म होने में"}</p>
            <Countdown end={fe.end_date} />
          </div>
        )}
      </div>
    </div>
  );
}
